import gql from 'graphql-tag'
import { logger } from 'logger'
import { makesMutations } from 'data/graphql'

const unfurlUrlMutation = gql`
  mutation unfurlIntegrationUrl(
    $url: String!
    $tileId: String!
    $noteId: String!
  ) {
    unfurlIntegrationURL(input: { url: $url, tileId: $tileId, noteId: $noteId })
  }
`

const providesUnfurlIntegrationUrl = makesMutations({
  query: unfurlUrlMutation,
  mutationPropName: 'unfurlIntegrationUrl',
  getOnErrorFromProps: () => result => {
    logger.error('Error while unfurling URL', result)
  },
})

export default providesUnfurlIntegrationUrl
